export function getDateFormatParts(locale) {
    if (!locale) {
        return [];
    }
    try {
        const format = Intl.DateTimeFormat(locale, {
            dateStyle: 'short',
            timeStyle: 'medium'
        });
        return format.formatToParts(Date.now()).filter((part)=>part.type !== 'literal').map((part)=>part.type);
    } catch  {
        return [];
    }
}
export var SupportedDateParts = /*#__PURE__*/ function(SupportedDateParts) {
    SupportedDateParts["DAY"] = "DAY";
    SupportedDateParts["MONTH"] = "MONTH";
    SupportedDateParts["YEAR"] = "YEAR";
    return SupportedDateParts;
}({});
const supportedPartsValues = Object.values(SupportedDateParts);
export const isSupportedDatePart = (part)=>supportedPartsValues.includes(part.toUpperCase());

//# sourceMappingURL=date-format-parts.js.map